import type { ApiResponse } from '@owl-nest/api-client'
import * as api from '@owl-nest/api-client/next'

export async function get(
  newsPieceId: number,
  withToken = false,
  accessToken?: string,
): Promise<ApiResponse<api.News>> {
  const response = await api.client('GET /news/:id', {
    token: accessToken,
    urlParams: { id: String(newsPieceId) },
    withToken,
  })

  // FIXME: TODO: Handle errors
  return response.next((success) => success.body)
}

export async function getPage(
  projectId: number | string,
  getParams?: URLSearchParams,
  withToken = true,
  accessToken?: string,
): Promise<ApiResponse<api.NewsListPage>> {
  const response = await api.client('GET /projects/:id/news', {
    token: accessToken,
    urlParams: { id: String(projectId) },
    getParams,
    withToken,
  })

  return response.next((success) => success.body)
}

export async function createDraft(projectId: number | string, payload: api.CreateNews): Promise<ApiResponse<api.News>> {
  const response = await api.client('POST /projects/:id/news', {
    urlParams: { id: String(projectId) },
    body: payload,
    withToken: true,
  })

  return response.next((success) => success.body)
}

export async function publishDraft(newsId: number): Promise<ApiResponse<api.News>> {
  const response = await api.client('POST /news/:id/publish', {
    urlParams: { id: String(newsId) },
    withToken: true,
  })

  return response.next((success) => success.body)
}

export async function unpublishPost(newsId: number): Promise<ApiResponse<api.News>> {
  const response = await api.client('POST /news/:id/unpublish', {
    urlParams: { id: String(newsId) },
    withToken: true,
  })

  return response.next((success) => success.body)
}

export async function updatePost(newsId: number, payload: api.CreateNews): Promise<ApiResponse<api.News>> {
  const response = await api.client('PATCH /news/:id', {
    body: payload,
    urlParams: { id: String(newsId) },
    withToken: true,
  })

  return response.next((success) => success.body)
}

export async function deletePost(newsId: number): Promise<ApiResponse<void>> {
  const response = await api.client('DELETE /news/:id', {
    urlParams: { id: String(newsId) },
    withToken: true,
  })

  return response.next((success) => success.body)
}

export async function tryNewsEmailing(newsId: number): Promise<ApiResponse<void>> {
  const response = await api.client('POST /news/:id/try', {
    urlParams: { id: String(newsId) },
    withToken: true,
  })

  return response.next((success) => success.body)
}
